import { useMemo } from 'react';
import { useAuth } from '@amzn/neura-web-shared-components';
import {
  UserRole,
  Permission,
  resolveEffectiveRole,
  getPermissionsForRole,
  hasPermission as registryHasPermission,
  isAtLeastRole as registryIsAtLeastRole,
} from '@amzn/neura-knowledge-management-model';

interface UsePermissionsReturn {
  role: UserRole;
  permissions: Permission[];
  hasPermission: (permission: Permission) => boolean;
  hasAnyPermission: (...permissions: Permission[]) => boolean;
  isAtLeastRole: (minimumRole: UserRole) => boolean;
}

export function usePermissions(): UsePermissionsReturn {
  const { user } = useAuth();

  return useMemo(() => {
    const groups = user?.groups ?? [];
    const role = resolveEffectiveRole(groups);
    const permissions = getPermissionsForRole(role);

    return {
      role,
      permissions,
      hasPermission: (permission: Permission) => registryHasPermission(role, permission),
      hasAnyPermission: (...perms: Permission[]) => perms.some(p => registryHasPermission(role, p)),
      isAtLeastRole: (minimumRole: UserRole) => registryIsAtLeastRole(role, minimumRole),
    };
  }, [user?.groups]);
}
